import { Link } from "react-router-dom";

export default function TipCta() {
  return (
    <section className="w-full bg-background-50 px-4 pb-12 pt-4 md:px-6 md:pb-16 lg:px-10">
      <div className="overflow-hidden rounded-lg border border-primary-200 bg-primary-500">
        <div className="grid grid-cols-1 items-center gap-6 px-6 py-8 md:grid-cols-3 md:px-10 md:py-12">
          <div className="md:col-span-2">
            <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50/15 px-3 py-1 text-xs font-medium text-background-50">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-inbox-archive-line text-sm"></i>
              </span>
              线索征集
            </span>
            <h2 className="mt-4 font-heading text-xl font-bold leading-snug text-background-50 md:text-3xl">
              手里有 511 爆料 的补充材料？
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-primary-100">
              无论是一张更清晰的原始截图、一份时间更早的文件，还是与现有说法矛盾的一手记录，都欢迎提交给我们加入对照表。请尽量附上可回查的出处。
            </p>
          </div>
          <div className="flex flex-col gap-3 md:items-end">
            <Link
              to="/about#tips"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-5 py-3 text-sm font-medium text-primary-700 transition-colors hover:bg-background-100"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-upload-cloud-2-line text-base"></i>
              </span>
              提交线索
            </Link>
            <Link
              to="/faq"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              先看求证说明
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}